module.exports=function(scope){ return `curl -X POST \
'https://api.zoomauth.com/api/v2/biometrics/id-check' \
-H 'Content-Type: application/json' \
-H 'X-Device-License-Key: ${scope.appToken}' \
-H 'X-User-Agent: ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)' \
-d '{
  "sessionId": INSERT_SESSION_ID_FROM_zoomSessionResult,
  "faceMap": INSERT_FACEMAP_FROM_zoomSessionResult,
  "idScan": INSERT_ID_SCAN_HERE,
  "idScanFrontImage": INSERT_ID_SCAN_FRONT_IMAGE_FROM_zoomIDScanResult,
  "idScanBackImage": INSERT_ID_SCAN_BACK_IMAGE_FROM_zoomIDScanResult
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/id-check.bash.tpl